module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-16x9-315bd5ff724ab1cec967d9def700ccca.jpg";